import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "md:px-4" }
const _hoisted_2 = {
  key: 0,
  class: "text-xs text-amber-100! text-center"
}
const _hoisted_3 = {
  key: 1,
  class: "text-[10px] text-amber-100! font-bold text-center"
}
const _hoisted_4 = { class: "text-sm block mb-4" }
const _hoisted_5 = { class: "font-bold" }
const _hoisted_6 = { class: "text-[12px]" }
const _hoisted_7 = {
  key: 0,
  class: "flex justify-end gap-2"
}

export function render(_ctx, _cache) {
  const _component_PopupMainNavbar = _resolveComponent("PopupMainNavbar")
  const _component_PopupPromotionNavbar = _resolveComponent("PopupPromotionNavbar")
  const _component_Button = _resolveComponent("Button")
  const _component_Column = _resolveComponent("Column")
  const _component_Tag = _resolveComponent("Tag")
  const _component_DataTable = _resolveComponent("DataTable")
  const _component_Paginator = _resolveComponent("Paginator")
  const _component_Card = _resolveComponent("Card")
  const _component_Dialog = _resolveComponent("Dialog")

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_PopupMainNavbar),
    _createVNode(_component_PopupPromotionNavbar),
    _createElementVNode("div", _hoisted_1, [
      _cache[3] || (_cache[3] = _createElementVNode("h2", { class: "text-xl text-amber-100 text-start font-extrabold my-3" }, "รายการโบนัส", -1 /* HOISTED */)),
      _createVNode(_component_Card, { pt: {root:'bg-[#34513bd4]! border-4! border-[#34513b]!', body: 'px-2!'} }, {
        content: _withCtx(() => [
          _createVNode(_component_DataTable, {
            value: _ctx.bonusList,
            loading: _ctx.tableLoading,
            scrollable: "",
            scrollHeight: "400px",
            tableStyle: "min-width: 35rem;",
            size: "small",
            class: "table-auto w-full bg-[#6bbc9e]!",
            pt: {tableContainer: 'min-h-[250px]', thead: 'bg-[#5e8367d4]!', tbody: '', bodyRow: 'border-0!', emptyMessage: 'bg-transparent!'}
          }, {
            empty: _withCtx(() => [
              (_ctx.tableLoading)
                ? (_openBlock(), _createElementBlock("p", _hoisted_2, "กำลังโหลดข้อมูล"))
                : (_openBlock(), _createElementBlock("p", _hoisted_3, "ไม่พบข้อมูล"))
            ]),
            default: _withCtx(() => [
              _createVNode(_component_Column, {
                "header-class": "text-xs bg-[#39a78e]! text-amber-100!",
                "body-class": "text-xs bg-[#6bbc9e]! text-amber-100!",
                pt: {headerCell:'bg-transparent! text-amber-50!'}
              }, {
                body: _withCtx((slotProps) => [
                  _createVNode(_component_Button, {
                    onClick: $event => (_ctx.clickReceiveBonus($event, slotProps.data)),
                    label: "รับโบนัส",
                    size: "small",
                    class: "text-xs! py-1!",
                    disabled: slotProps.data.status !== 'PENDING'
                  }, null, 8 /* PROPS */, ["onClick", "disabled"])
                ]),
                _: 1 /* STABLE */
              }),
              _createVNode(_component_Column, {
                field: "amount",
                header: "โบนัส",
                "header-class": "text-xs bg-[#39a78e]! text-amber-100!",
                "body-class": "text-xs bg-[#6bbc9e]! text-amber-100!",
                pt: {headerCell:'bg-transparent! text-amber-50!'}
              }, {
                body: _withCtx((slotProps) => [
                  _createTextVNode(_toDisplayString(_ctx.formatCurrency(slotProps.data.amount)), 1 /* TEXT */)
                ]),
                _: 1 /* STABLE */
              }),
              _createVNode(_component_Column, {
                field: "maxWithdraw",
                header: "ถอนสูงสุด",
                "header-class": "text-xs bg-[#39a78e]! text-amber-100!",
                "body-class": "text-xs bg-[#6bbc9e]! text-amber-100!",
                pt: {headerCell:'bg-transparent! text-amber-50!'}
              }, {
                body: _withCtx((slotProps) => [
                  _createTextVNode(_toDisplayString(slotProps.data.maxWithdraw) + " เท่า ", 1 /* TEXT */)
                ]),
                _: 1 /* STABLE */
              }),
              _createVNode(_component_Column, {
                field: "status",
                header: "สถานะ",
                "header-class": "text-xs bg-[#39a78e]! text-amber-100!",
                "body-class": "text-xs bg-[#6bbc9e]! text-amber-100!",
                pt: {headerCell:'bg-transparent! text-amber-50!'}
              }, {
                body: _withCtx((slotProps) => [
                  (slotProps.data.status === 'SUCCESS')
                    ? (_openBlock(), _createBlock(_component_Tag, {
                        key: 0,
                        severity: "success",
                        value: "สำเร็จ",
                        pt: { label: 'text-xs!' }
                      }))
                    : (slotProps.data.status === 'PENDING')
                      ? (_openBlock(), _createBlock(_component_Tag, {
                          key: 1,
                          severity: "info",
                          value: "รอดำเนินการ",
                          pt: { label: 'text-xs!' }
                        }))
                      : (_openBlock(), _createBlock(_component_Tag, {
                          key: 2,
                          severity: "danger",
                          value: "ถูกปฏิเสธ",
                          pt: { label: 'text-xs!' }
                        }))
                ]),
                _: 1 /* STABLE */
              }),
              _createVNode(_component_Column, {
                field: "endDate",
                header: "สิ้นสุด",
                "header-class": "text-xs bg-[#39a78e]! text-amber-100!",
                "body-class": "text-xs bg-[#6bbc9e]! text-amber-100!",
                pt: {headerCell:'bg-transparent! text-amber-50!'}
              }, {
                body: _withCtx((slotProps) => [
                  _createTextVNode(_toDisplayString(_ctx.formatThaiDateTime(slotProps.data.endDate)), 1 /* TEXT */)
                ]),
                _: 1 /* STABLE */
              })
            ]),
            _: 1 /* STABLE */
          }, 8 /* PROPS */, ["value", "loading"]),
          _createVNode(_component_Paginator, {
            first: _ctx.first,
            "onUpdate:first": _cache[0] || (_cache[0] = $event => ((_ctx.first) = $event)),
            rows: _ctx.rows,
            totalRecords: _ctx.totalRecords,
            template: "PrevPageLink CurrentPageReport NextPageLink",
            currentPageReportTemplate: "{first} ถึง {last} ทั้งหมด {totalRecords}",
            pt: { root: 'bg-[#24402bd4]! border-2! border-[#14361c]! px-0! mt-5!', current: 'text-xs! text-amber-100!', first: 'text-amber-50!', last: 'text-amber-50!', prev: 'text-amber-50!', next: 'text-amber-50!' },
            onPage: _ctx.onPageChange
          }, null, 8 /* PROPS */, ["first", "rows", "totalRecords", "onPage"])
        ]),
        _: 1 /* STABLE */
      })
    ]),
    _createVNode(_component_Dialog, {
      visible: _ctx.visible,
      "onUpdate:visible": _cache[2] || (_cache[2] = $event => ((_ctx.visible) = $event)),
      modal: "",
      header: "ยืนยันรับโบนัส",
      style: { width: '25rem' }
    }, {
      default: _withCtx(() => [
        _createElementVNode("span", _hoisted_4, [
          (_ctx.dialogLoading)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createTextVNode(" กำลังโหลดข้อมูล... ")
              ], 64 /* STABLE_FRAGMENT */))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                _cache[4] || (_cache[4] = _createTextVNode(" รับโบนัสจำนวน ")),
                _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.formatCurrency(_ctx.bonusConfirm?.amount || 0)), 1 /* TEXT */),
                _cache[5] || (_cache[5] = _createElementVNode("br", null, null, -1 /* HOISTED */)),
                _createElementVNode("span", _hoisted_6, "ถอนสูงสุด: " + _toDisplayString(_ctx.bonusConfirm?.maxWithdraw) + " เท่า", 1 /* TEXT */)
              ], 64 /* STABLE_FRAGMENT */))
        ]),
        (!_ctx.dialogLoading)
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
              _createVNode(_component_Button, {
                type: "button",
                label: "ยกเลิก",
                severity: "secondary",
                onClick: _cache[1] || (_cache[1] = $event => (_ctx.visible = false))
              }),
              _createVNode(_component_Button, {
                type: "button",
                label: "ยืนยัน",
                onClick: _ctx.receiveBonus
              }, null, 8 /* PROPS */, ["onClick"])
            ]))
          : _createCommentVNode("v-if", true)
      ]),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["visible"])
  ]))
}